import format from 'string-format';
import { extendObservable, action } from 'mobx';
import firebase from 'firebase';

import WarningStrings from '../strings/en/warning';
import Passcode from '../models/Passcode';

const PasscodeRef = firebase.database().ref("/passcodes");

class PasscodeStore {
  constructor() {
    extendObservable(this, {
      property: null,
      passcodes: [],
    });
  }

  add = (passcode) => {
    // todo: handle error, no userId or propertyId
    let {
      userId,
      id: propertyId,
    } = this.property;
    const ref = PasscodeRef.child(`${userId}/${propertyId}`);
    passcode.set({
      id: ref.push().key,
      userId: userId,
      propertyId: propertyId,
    });
    let data = {};
    data[passcode.id] = passcode.get();
    return ref.update(data)
              .then(action(() => this.passcodes.push(passcode)));
  };

  update = (passcode) => {
    // todo: handle error, no userId or propertyId
    // todo: check if property exists
    // check if passcode exists
    let pc = this.getById(passcode.id);
    // update passcode
    const ref = PasscodeRef.child(`${passcode.userId}/${passcode.propertyId}/${passcode.id}`);
    return ref.update(passcode.get())
              .then(action(() => pc.set(passcode.get())));
  }

  delete = (passcode) => {
    // todo: check if property exists
    // check if passcode exists
    let pc = this.getById(passcode.id);
    // delete
    const ref = PasscodeRef.child(`${passcode.userId}/${passcode.propertyId}/${passcode.id}`);
    return ref.remove()
              .then(action(() => {
                const index = this.passcodes.indexOf(pc);
                if (index !== -1) {
                  this.passcodes.splice(index, 1);
                }
              }));
  }

  getById = (passcodeId) => {
    if (!passcodeId) {
      return null;
    }
    let pc = this.passcodes.find((pc) => pc.id === passcodeId);
    if (!pc) {
      throw format(WarningStrings.PasscodeNotExists, passcodeId);
    }
    return pc;
  }

  setProperty = action((property) => {
    // reset
    this.property = property;
    this.passcodes.replace([]);
    // check if property null
    if (!property) {
      return new Promise((resolve, reject) => resolve());
    }
    // get passcodes
    return PasscodeRef.child(`${property.userId}/${property.id}`)
    .once("value").then(action((snapshot) => {
      let passcodes = [];
      snapshot.forEach((passcode) => {
        passcodes.push(new Passcode(passcode.val()));
      });
      this.passcodes.replace(passcodes);
    }));
  });

  clearProperty = action(() => {
    this.property = null;
    this.passcodes.replace([]);
  });
}

const passcodeStore = new PasscodeStore();

export default passcodeStore;
export { PasscodeStore }; // why?


// WEBPACK FOOTER //
// ./src/stores/PasscodeStore.js